import _, { template } from 'lodash';

const initialState = {
	priceTemplates: null,
	editTemplatePayload: null,
	templateId:''
};

export default function exports(state = initialState, action) {
    switch (action.type) {
		case 'SET_EDIT_TEMPLATE_PAYLOAD':
			return {...state,
				editTemplatePayload: action.data
			}
		case 'SAVE_PRICE_TEMPLATES':
			if(action.data && action.data.responseObject) {
				action.data.responseObject = _.sortBy(action.data.responseObject, "templateName");
			}
			return {...state,
				priceTemplates: action.data
			}
		case 'SAVE_TEMPLATE_ID':
			return {...state,
				templateId: action.data
			}
		case 'RESET_EXPORTS_REDUCERS':
			return initialState;
	    default:
	        return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/exports.js